(function () {
  const frame_end_delay = "+=1"
  // 年份 -> ScrollTrigger 实例注册表，供 init_menu 跳转到 title_end 标签位置
  const year_scroll_triggers = {}

  // 公共平滑滚动：GSAP power2.inOut 缓动 + 按距离动态时长（500ms~2000ms），无需 ScrollToPlugin
  const scroll_proxy = { y: 0 }
  // 用户手动滚动（滚轮/触摸）时终止动画，避免拉扯（原生监听，不依赖 jQuery 加载时机）
  const kill_scroll_tween = () => gsap.killTweensOf(scroll_proxy)
  window.addEventListener('wheel', kill_scroll_tween, { passive: true })
  window.addEventListener('touchstart', kill_scroll_tween, { passive: true })
  function smooth_scroll_to(target) {
    const distance = Math.abs(target - window.scrollY)
    const duration = Math.min(2000, Math.max(500, distance * 0.5)) / 1000
    // 终止上一次滚动动画，连续触发不叠加打架
    gsap.killTweensOf(scroll_proxy)
    scroll_proxy.y = window.scrollY
    gsap.to(scroll_proxy, {
      y: target,
      duration: duration,
      ease: "power2.inOut",
      onUpdate: () => window.scrollTo(0, scroll_proxy.y)
    })
  }

  // 立即揭幕全部图片（绕过懒加载，与最终渲染同一次请求），等全部加载完成后再回调
  // onerror 也计数，单图失败不卡死；超时兜底强制放行
  function init_preload(on_done) {
    const imgs = [...document.querySelectorAll('#MainContent img')]
    // 原生 lazy 改立即加载
    imgs.forEach(img => { if (img.loading === 'lazy') img.loading = 'eager' })
    // 库图片：调用 unveil 让库自己做 data-src+data-widths → srcset 的宽度替换
    // 注意：不能手动换 src（data-src 是 width=1 占位图），也不能移除 lazyloadt4s 类
    const ls = window.lazySizesT4
    if (ls && ls.loader && ls.loader.unveil) {
      imgs.forEach(img => {
        if (img.dataset.src || img.dataset.srcset) ls.loader.unveil(img)
      })
    }
    // 等全部加载完成
    let remaining = imgs.length
    let finished = false
    const finish = () => { if (!finished) { finished = true; on_done() } }
    if (!remaining) return finish()
    const tick = () => { if (--remaining <= 0) finish() }
    imgs.forEach(img => {
      // 刚 unveile 的图必然要重新加载，其旧 complete（1px 占位）不可信
      if (!(img.dataset.src || img.dataset.srcset) && img.complete) return tick()
      img.addEventListener('load', tick, { once: true })
      img.addEventListener('error', tick, { once: true })
    })
    setTimeout(finish, 10000)
  }

  function year_title_animation(tl, class_name, index = 1) {
    if (tl.scrollTrigger) year_scroll_triggers[class_name] = tl.scrollTrigger
    tl.addLabel("title_start")
    tl.fromTo(`.${class_name} .t4s-custom-col:nth-of-type(${index}) h3`, { y: "+=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.fromTo(`.${class_name} .t4s-custom-col:nth-of-type(${index}) h4`, { y: "-=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '<')
    tl.fromTo(`.${class_name} .t4s-custom-col:nth-of-type(${index}) p`, { y: "-=10", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.addLabel("title_end", '<')
  }
  function select_item_show(tl, big_photo, small_photo, total, extend_photos = {}, enable_hover = false, extra_animation = {}) {
    const real_total = total + 1
    for (let i = 2; i <= real_total; i++) {
      tl.fromTo(`${big_photo} .t4s-img-child:nth-of-type(1)`, { x: "+=5", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      tl.fromTo(`${big_photo} .t4s-img-child:nth-of-type(${i})`, { x: "+=5", autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, '>')
      tl.fromTo(`${small_photo} .t4s-img-child:nth-of-type(${i - 1})`, { scale: 1 }, { scale: 1.1 }, '<')

      if (extra_animation[i]) {
        tl.fromTo(extra_animation[i].enter.target, extra_animation[i].enter.from, extra_animation[i].enter.to, '<')
      }
      tl.to(`${big_photo} .t4s-img-child:nth-of-type(1)`, { autoAlpha: 1 }, "+=1")
      if (enable_hover) tl.addLabel(`item_${i}`, '>')
      if (extra_animation[i] && extra_animation[i].exit) {
        tl.to(extra_animation[i].exit.target, extra_animation[i].exit.to, '>')
      }

      tl.to(`${big_photo} .t4s-img-child:nth-of-type(${i})`, { autoAlpha: 0 })
      tl.to(`${small_photo} .t4s-img-child:nth-of-type(${i - 1})`, { scale: 1 }, '<')
      tl.to(`${big_photo} .t4s-img-child:nth-of-type(1)`, { x: "-=5", autoAlpha: 0 }, '<')
    }

    if (enable_hover) {
      // === hover 交互：播放到对应帧标记处停住 ===
      for (let i = 1; i <= total; i++) {
        const smallEl = `${small_photo} .t4s-img-child:nth-of-type(${i})`
        const label = `item_${i + 1}`
        let wasPlaying = false
        let hoverTween = null
        $(smallEl).on('mouseenter', function () {
          wasPlaying = !tl.paused()
          tl.pause()
          if (hoverTween) hoverTween.kill()
          hoverTween = tl.tweenTo(label, { duration: 0.5 })
        }).on('mouseleave', function () {
          if (hoverTween) { hoverTween.kill(); hoverTween = null }
          if (wasPlaying) tl.resume()
        })
      }
    }

  }

  function photo_slice_frame_on_complete(year, index) {
    // 清除所有，只高亮当前
    const base_class = `.${year} .photo_slide_pagination`
    $(`${base_class} li`).removeClass('is_selected');
    $(`${base_class} li:nth-of-type(${index})`).addClass('is_selected');
  }
  function photo_slice_frame_pagination_on_click(year, loopTl) {
    const $lis = $(`.${year} .photo_slide_pagination li`)
    // 幂等：先解绑，避免 matchMedia 重跑或重复初始化时叠加多个 click
    $lis.off('click')
    $lis.click(function () {
      const f_index = $(this).index() + 1
      loopTl.play(`frame_${f_index}`)
    })
  }
  function photo_slice_frame_pagination(year, page = 2) {
    const base_class = `.${year} .t4s-row`
    // 幂等：先移除已存在的分页，避免 matchMedia 重跑时重复累加
    $(`${base_class} .photo_slide_pagination`).remove()
    let html = '<ul class="photo_slide_pagination">'
    for (let i = 0; i < page; i++) {
      html += '<li />'
    }
    html += '</ul>'
    $(base_class).append(html)
  }
  function init_begin() {
    // const is_mobile = MB_is_mobile()
    const is_mobile = true
    // PC：挂 ScrollTrigger，下滑到 forgebytime 顶部才播放；
    // 手机：不挂 ScrollTrigger（返回 paused 的 tl），由 init_preload 完成后直接 play
    const tl = gsap.timeline({
      onStart: () => { $(".forgebytime.is_tipsing").removeClass('is_tipsing') },
      defaults: { immediateRender: true },
      paused: is_mobile,
      ...(is_mobile ? {} : {
        scrollTrigger: {
          trigger: ".forgebytime",
          start: "top 0%",
          end: "bottom 50%",
          toggleActions: "play none none none",
          // markers: true
        }
      })
    });
    const year = 'forgebytime'
    const base_class = `.${year} .t4s-custom-col:nth-of-type(1) .t4s-w-100`

    // gsap.fromTo(`${base_class} > :nth-child(8)`, { y: '+=30', autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, "+=1")
    // gsap.fromTo(`${base_class} > :nth-child(9)`, { y: '+=10', autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '+=0.4')

    tl.fromTo(".forgebytime .t4s-img-as-bg", { scale: 1.3, autoAlpha: 0.2 }, { scale: 1, autoAlpha: 1 })
    tl.fromTo(`${base_class} > :nth-child(2)`, { scale: 1.2, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 })
    tl.fromTo(`${base_class} > :nth-child(3)`, { scaleX: 0.3, autoAlpha: 0 }, { scaleX: 1, autoAlpha: 1 }, '-=0.3')
    tl.fromTo(`${base_class} > :nth-child(1)`, { y: "+=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '+=0')
    tl.fromTo(`${base_class} > :nth-child(4)`, { x: "+=20", autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, '-=0.5')
    tl.fromTo(`${base_class} > :nth-child(5)`, { x: "-=20", autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, '-=0.5')
    tl.fromTo(`${base_class} > :nth-child(6)`, { y: "-=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.5')
    tl.fromTo(`${base_class} > :nth-child(7)`, { y: "-=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class} > :nth-child(8)`, { y: "+=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '+=0')
    tl.fromTo(`${base_class} > :nth-child(9)`, { y: "+=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '-=0.1')
    tl.to(`${base_class}`, { autoAlpha: 1 }, `${frame_end_delay}`)

    return tl
  }
  function init_y1936() {
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y1936",
        // scrub: true
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        onLeaveBack: () => loopTl.pause(0)
      }
    });
    const year = 'y1936'
    const base_class1 = `.${year} .t4s-custom-col:nth-of-type(1)`
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    const base_class3 = `.${year} .t4s-custom-col:nth-of-type(3)`
    year_title_animation(tl, year)
    photo_slice_frame_pagination(year, 2)

    // 两帧照片无限循环子 tl
    const loopTl = gsap.timeline({ repeat: -1, paused: true });

    loopTl.call(() => photo_slice_frame_on_complete(year, 1))
    loopTl.addLabel('frame_1', ">")
    loopTl.fromTo(`${base_class2}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "+=30", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(3)`, { x: "-=30", autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, '-=0.5')
    loopTl.to(`${base_class2}`, { delay: 4 })
    loopTl.to(`${base_class2}`, { x: "-=20", autoAlpha: 0 })

    loopTl.call(() => photo_slice_frame_on_complete(year, 2))
    loopTl.addLabel('frame_2', ">")
    loopTl.fromTo(`${base_class3}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(2)`, { y: "-=10", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    loopTl.to(`${base_class3}`, { delay: 4 })
    loopTl.to(`${base_class3}`, { x: "-=20", autoAlpha: 0 })

    tl.to(`${base_class1}`, { autoAlpha: 1 })
    tl.call(() => loopTl.play())

    photo_slice_frame_pagination_on_click(year, loopTl)

  }
  function init_y1940() {
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y1940",
        start: "top 0%",
        end: "bottom 50%",
        // markers: true,
        // scrub: true,
        toggleActions: "play none none reverse",
        // onToggle: (self) => console.log('[y1940]', self, self.direction, self.isActive, self.progress)
      }
    });
    const year = 'y1940'
    const base_class = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    year_title_animation(tl, year)
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(1)`, { x: "-=60", scale: 0.95, autoAlpha: 0 }, { x: 0, scale: 1, autoAlpha: 1 })
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(2)`, { x: "-=30", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(3), ${base_class} .t4s-img-child:nth-of-type(5)`, { x: "+=2", y: "+=10", autoAlpha: 0 }, { x: 0, y: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(6)`, { scale: 1.05, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 }, "<")
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(4)`, { x: "+=4", y: "+=30", autoAlpha: 0 }, { x: 0, y: 0, autoAlpha: 1 })
    tl.to(`${base_class}`, { autoAlpha: 1 }, `${frame_end_delay}`)
  }
  function init_y1950s() {
    const tl = gsap.timeline({
      // defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y1950s",
        start: "top 0%",
        toggleActions: "play none none reverse",
        // markers: true,
        onLeaveBack: () => loopTl.pause(0)
      }
    });
    const year = 'y1950s'
    const base_class1 = `.${year} .t4s-custom-col:nth-of-type(1) .t4s-w-100`
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    const base_class3 = `.${year} .t4s-custom-col:nth-of-type(3) .t4s-w-100`

    // === 前置动画（循环前播放，此时 loopTl 处于 stop） ===
    year_title_animation(tl, year)
    tl.fromTo(`${base_class3}`, { y: "-=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })

    // === 循环独立，初始 paused ===
    const loopTl = gsap.timeline({ repeat: -1, paused: true });
    const extra_animation = {
      "2": {
        enter: {
          target: `${base_class2} .t4s-img-child:nth-of-type(6)`,
          from: { x: "+=20", autoAlpha: 0 },
          to: { x: 0, autoAlpha: 1 }
        },
        exit: {
          target: `${base_class2} .t4s-img-child:nth-of-type(6)`,
          to: { autoAlpha: 0 }
        }
      },
      "3": {
        enter: {
          target: `${base_class2} .t4s-img-child:nth-of-type(8)`,
          from: { x: "+=20", autoAlpha: 0 },
          to: { x: 0, autoAlpha: 1 }
        },
        exit: {
          target: `${base_class2} .t4s-img-child:nth-of-type(8)`,
          to: { autoAlpha: 0 }
        }
      },
      "4": {
        enter: {
          target: `${base_class2} .t4s-img-child:nth-of-type(7)`,
          from: { x: "+=20", autoAlpha: 0 },
          to: { x: 0, autoAlpha: 1 }
        },
        exit: {
          target: `${base_class2} .t4s-img-child:nth-of-type(7)`,
          to: { autoAlpha: 0 }
        }
      }
    }
    select_item_show(loopTl, base_class2, base_class3, 4, {}, true, extra_animation)

    // === 前置动画播完 → 启动循环（放在 base_class3 滑入之后） ===
    tl.call(() => loopTl.play())
    tl.to(`${base_class1}`, { autoAlpha: 1 }, `${frame_end_delay}`)
  }
  function init_y1960s() {
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y1960s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        // onLeaveBack: () => loopTl.tweenTo(0).pause()
      }
    });
    const year = 'y1960s'
    const base_class1 = `.${year} .t4s-custom-col:nth-of-type(1) .t4s-w-100`
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    const base_class3 = `.${year} .t4s-custom-col:nth-of-type(3)`
    year_title_animation(tl, year)
    tl.fromTo(`${base_class1} .t4s-img-child:nth-of-type(4)`, { autoAlpha: 0 }, { autoAlpha: 1 })
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(1)`, { y: "-=20", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "-=40", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })


    // photo_slice_frame_pagination(year, 2)

    // 两帧照片无限循环子 tl
    // const loopTl = gsap.timeline({ repeat: -1, paused: true });
    // loopTl.call(() => photo_slice_frame_on_complete(year, 1))
    // loopTl.addLabel('frame_1', "<")
    // loopTl.fromTo(`${base_class2}`,
    //   { x: "+=20", autoAlpha: 0 },
    //   { x: 0, autoAlpha: 1 }
    // )
    // loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(1)`, { x: "-=20", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    // loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "-=40", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    // loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(3)`, { x: "-=20", scale: 1.05, autoAlpha: 0 }, { x: 0, scale: 1, autoAlpha: 1 })
    // loopTl.to(`${base_class2}`, { delay: 0.5 })
    // loopTl.to(`${base_class2}`, { x: "-=20", autoAlpha: 0 })

    // loopTl.call(() => photo_slice_frame_on_complete(year, 2))
    // loopTl.addLabel('frame_2', "<")
    // loopTl.fromTo(`${base_class3}`,
    //   { x: "+=20", autoAlpha: 0 },
    //   { x: 0, autoAlpha: 1 }
    // )
    // // loopTl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(2)`, { y: "-=10", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    // loopTl.to(`${base_class3}`, { delay: 0.5 })
    // loopTl.to(`${base_class3}`, { x: "-=20", autoAlpha: 0 })

    // tl.to(`${base_class1}`, { autoAlpha: 1 })
    // tl.call(() => loopTl.play())
    // photo_slice_frame_pagination_on_click(year, loopTl)

  }
  function init_y1970s() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".y1970s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
      }
    });
    const year = 'y1970s'
    const base_class = `.${year} .t4s-custom-col:nth-of-type(2)`
    year_title_animation(tl, year)
    tl.fromTo(`${base_class} .t4s-img-child:nth-of-type(1)`, { x: "-=40", scale: 1.03, autoAlpha: 0 }, { x: 0, scale: 1, autoAlpha: 1, transformOrigin: "bottom center" })
    tl.to(`${base_class}`, { autoAlpha: 1 }, `${frame_end_delay}`)
  }
  function init_y1980s() {
    const year = 'y1980s'
    const base_class1 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(1) .t4s-w-100`
    const base_class2 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(2)`
    const base_class3 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(3)`
    // const base_class4 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(4)`
    let loop_is_running = false

    // 三帧照片无限循环子 tl
    const loopTl = gsap.timeline({ repeat: -1, paused: true });

    loopTl.call(() => photo_slice_frame_on_complete(year, 1))
    loopTl.addLabel('frame_1', "<")
    loopTl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(3)`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.to(`${base_class2}`, { delay: 2 })
    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(3)`, { x: "-=20", autoAlpha: 0 })

    loopTl.call(() => photo_slice_frame_on_complete(year, 2))
    loopTl.addLabel('frame_2', "<")
    loopTl.fromTo(`${base_class3}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.to(`${base_class3}`, { delay: 2 })
    loopTl.to(`${base_class3}`, { x: "-=20", autoAlpha: 0 })
    photo_slice_frame_pagination(year, 2)
    photo_slice_frame_pagination_on_click(year, loopTl)

    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y1980s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        onLeaveBack: () => loopTl.pause(0)
      }
    });

    year_title_animation(tl, year)

    tl.call(() => loopTl.pause(0))
    // tl.call(() => loopTl.tweenTo(0, { duration: 0 }))
    tl.fromTo(`${base_class2}`, { autoAlpha: 0 }, { autoAlpha: 1 })
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "-=40", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(1)`, { x: "+=40", autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
    tl.call(() => loopTl.play())
    tl.to(`${base_class1}`, { autoAlpha: 1 }, '+=1')

  }
  function init_y1990s() {
    const year = 'y1990s'
    const bg_blcok = `.${year} .t4s-slideshow-inner>img`
    const base_class1 = `.${year} .t4s-custom-col:nth-of-type(1) .t4s-w-100`
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`

    // === 定位图标跟随背景图裁切 ===
    function updatePinPosition() {
      const container = document.querySelector(`.${year} .t4s-slideshow-inner`)
      // 按设备取对应的可见背景图（移动图 t4s-d-md-none / 桌面图 t4s-d-none t4s-d-md-block）
      const is_mobile = MB_is_mobile()
      const bgImgs = container ? container.querySelectorAll('.t4s-img-as-bg') : []
      const bgImg = is_mobile ? bgImgs[0] : bgImgs[1]
      const pin = document.querySelector(`${base_class1} .t4s-img-child`)

      if (!container || !bgImg || !pin) return

      // 图标在原始地图上的目标位置（百分比，0-1）
      // 根据 CSS 初始值: top: 35vh, left: 41.5vw 转换为百分比
      const TARGET_X = is_mobile ? 0.725 : 0.439
      const TARGET_Y = is_mobile ? 0.22 : 0.225
      // console.log(is_mobile, TARGET_X, TARGET_Y)

      const containerRect = container.getBoundingClientRect()
      const containerW = containerRect.width
      const containerH = containerRect.height

      // 获取图片原始尺寸
      const imgW = bgImg.naturalWidth || bgImg.width
      const imgH = bgImg.naturalHeight || bgImg.height

      if (!imgW || !imgH) return

      // 计算 object-fit: cover 的裁切
      const containerRatio = containerW / containerH
      const imgRatio = imgW / imgH

      let scale, visibleW, visibleH, offsetX, offsetY

      if (containerRatio > imgRatio) {
        // 容器更宽，图片按宽度适配，垂直方向裁切
        scale = containerW / imgW
        visibleW = containerW
        visibleH = imgH * scale
        offsetX = 0
        offsetY = (visibleH - containerH) / 2
      } else {
        // 容器更高，图片按高度适配，水平方向裁切
        scale = containerH / imgH
        visibleW = imgW * scale
        visibleH = containerH
        offsetX = (visibleW - containerW) / 2
        offsetY = 0
      }

      // 计算图标中心在可见区域中的位置（不夹带像素补偿，TARGET 即图上真实坐标）
      const pinX = (TARGET_X * visibleW - offsetX) / containerW * 100
      const pinY = (TARGET_Y * visibleH - offsetY) / containerH * 100

      // 更新图标位置
      pin.style.setProperty('--pin-top', `${pinY}%`)
      pin.style.setProperty('--pin-left', `${pinX}%`)
    }

    // 初始计算
    updatePinPosition()

    // 监听窗口大小变化
    window.addEventListener('resize', updatePinPosition)

    // 图片加载后重新计算
    const bgImg = document.querySelector(`.${year} .t4s-img-as-bg`)
    if (bgImg) {
      bgImg.addEventListener('load', updatePinPosition)
    }

    const loopTl = gsap.timeline()

    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(1)`, { scale: 1.8, duration: 0, transformOrigin: "80% left" })
    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "+=50%", scale: 0.3, duration: 0, transformOrigin: "80% right" }, "<")
    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(3)`, { scale: 0.3, duration: 0, transformOrigin: "80% right" }, "<")
    loopTl.addLabel(`img_1`, '>')

    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(1)`, { scale: 0.3, transformOrigin: "80% left" })
    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "-=10%", scale: 1.8, transformOrigin: "80% right" }, "<")
    loopTl.addLabel(`img_2`, '>')

    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(2)`, { x: "-=150%", scale: 0.3, transformOrigin: "80% right" })
    loopTl.to(`${base_class2} .t4s-img-child:nth-of-type(3)`, { scale: 1.8, transformOrigin: "80% right" }, "<")
    loopTl.addLabel(`img_3`, '>')

    loopTl.pause(0)

    // === 唯一一个 ScrollTrigger 挂在 tl 上，用 progress 计算播放点 ===
    let last_active_img_index = -1
    const tl = gsap.timeline({
      // defaults: { immediateRender: false },
      // paused: true,
      scrollTrigger: {
        trigger: ".y1990s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        // scrub: true,
        onUpdate: (self) => {
          const p = self.progress
          if (p >= 0.60 && p <= 0.66 && last_active_img_index != 2) { loopTl.tweenTo("img_3"); last_active_img_index = 2 }
          else if (p >= 0.40 && p <= 0.46 && last_active_img_index != 1) { loopTl.tweenTo("img_2"); last_active_img_index = 1 }
          else if (p <= 0.26 && last_active_img_index != 0) { loopTl.tweenTo("img_1"); last_active_img_index = 0 }
        },
        onLeaveBack: () => {
          loopTl.pause(0)
        }
      }
    });

    // === 前置动画 ===
    tl.fromTo(`${base_class1} .t4s-img-child`, { autoAlpha: 0 }, { autoAlpha: 1 })
    tl.fromTo(`${bg_blcok}`, { autoAlpha: 0 }, { autoAlpha: 1 }, ">")
    tl.fromTo(`${base_class1} .t4s-raw-html`, { autoAlpha: 0 }, { autoAlpha: 1 })
    year_title_animation(tl, year)
    tl.fromTo(`${base_class2}`, { autoAlpha: 0 }, { autoAlpha: 1 })
    tl.to(`${base_class1}`, { autoAlpha: 1 }, `5`)
    tl.to(`${base_class1}`, { autoAlpha: 1 }, `${frame_end_delay}`)

    const progress_list = [0.25, 0.45, 0.65]
    $(`${base_class2} .t4s-img-child`).click(function () {
      const index = $(this).index()
      const st = tl.scrollTrigger
      const targetScroll = st.start + (st.end - st.start) * progress_list[index]
      smooth_scroll_to(targetScroll)
    })
  }
  function init_y2000() {
    const year = 'y2000'
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2)`
    const base_class3 = `.${year} .t4s-custom-col:nth-of-type(3) .t4s-w-100`
    const mm = ScrollTrigger.matchMedia()

    // PC: 3 images side by side, slide in from right
    mm.add('(min-width: 769px)', () => {
      const tl = gsap.timeline({
        defaults: { immediateRender: true },
        scrollTrigger: {
          trigger: '.y2000',
          start: 'top 0%',
          end: 'bottom 50%',
          toggleActions: 'play none none reverse',
        }
      })
      year_title_animation(tl, year)
      tl.fromTo(base_class2, { y: '+=10', autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      tl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(1)`, { x: '+=30', autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      tl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(2)`, { x: '+=30', autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      tl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(3)`, { x: '+=30', autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      tl.to(`${base_class3}`, { autoAlpha: 1 }, `${frame_end_delay}`)
    })

    // Mobile: 3-image carousel with pagination
    mm.add('(max-width: 768px)', () => {
      const tl = gsap.timeline({
        defaults: { immediateRender: true },
        scrollTrigger: {
          trigger: '.y2000',
          start: 'top 0%',
          end: 'bottom 50%',
          toggleActions: 'play none none reverse',
          onLeaveBack: () => loopTl.pause(0)
        }
      })
      year_title_animation(tl, year)
      tl.fromTo(base_class2, { y: '+=10', autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      photo_slice_frame_pagination(year, 3)

      const loopTl = gsap.timeline({ repeat: -1, paused: true })

      loopTl.call(() => photo_slice_frame_on_complete(year, 1))
      loopTl.addLabel('frame_1', '>')
      loopTl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(1)`,
        { x: '+=30', autoAlpha: 0 },
        { x: 0, autoAlpha: 1 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(1)`, { delay: 2 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(1)`, { x: '-=30', autoAlpha: 0 })

      loopTl.call(() => photo_slice_frame_on_complete(year, 2))
      loopTl.addLabel('frame_2', '>')
      loopTl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(2)`,
        { x: '+=30', autoAlpha: 0 },
        { x: 0, autoAlpha: 1 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(2)`, { delay: 2 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(2)`, { x: '-=30', autoAlpha: 0 })

      loopTl.call(() => photo_slice_frame_on_complete(year, 3))
      loopTl.addLabel('frame_3', '>')
      loopTl.fromTo(`${base_class3} .t4s-img-child:nth-of-type(3)`,
        { x: '+=30', autoAlpha: 0 },
        { x: 0, autoAlpha: 1 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(3)`, { delay: 2 })
      loopTl.to(`${base_class3} .t4s-img-child:nth-of-type(3)`, { x: '-=30', autoAlpha: 0 })

      tl.call(() => loopTl.play())
      photo_slice_frame_pagination_on_click(year, loopTl)
    })
  }
  function init_y2010s() {
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y2010s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        onLeaveBack: () => loopTl.pause(0)
      }
    });
    const year = 'y2010s'
    const base_class1 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(1)`
    const base_class2 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(2)`
    const base_class3 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(3)`
    const base_class4 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(4)`
    // const base_class5 = `.${year} .t4s-row>.t4s-custom-col:nth-of-type(5)`

    year_title_animation(tl, year, 4)
    photo_slice_frame_pagination(year, 3)

    // 四帧照片无限循环子 tl
    const loopTl = gsap.timeline({ repeat: -1, paused: true });

    loopTl.call(() => photo_slice_frame_on_complete(year, 1))
    loopTl.addLabel(`frame_1`, '>')
    loopTl.fromTo(`${base_class1}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.to(`${base_class1}`, { delay: 4 })
    loopTl.to(`${base_class1}`, { x: "-=20", autoAlpha: 0 })

    loopTl.call(() => photo_slice_frame_on_complete(year, 2))
    loopTl.addLabel(`frame_2`, '>')
    loopTl.fromTo(`${base_class2}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.to(`${base_class2}`, { delay: 4 })
    loopTl.to(`${base_class2}`, { x: "-=20", autoAlpha: 0 })

    loopTl.call(() => photo_slice_frame_on_complete(year, 3))
    loopTl.addLabel(`frame_3`, '>')
    loopTl.fromTo(`${base_class3}`,
      { x: "+=20", autoAlpha: 0 },
      { x: 0, autoAlpha: 1 }
    )
    loopTl.to(`${base_class3}`, { delay: 4 })
    loopTl.to(`${base_class3}`, { x: "-=20", autoAlpha: 0 })

    tl.to(`${base_class4}`, { autoAlpha: 1 })
    tl.call(() => loopTl.play())
    photo_slice_frame_pagination_on_click(year, loopTl)
  }
  function init_y2021() {
    const year = 'y2021'
    const base_class = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y2021",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        // onLeaveBack: () => loopTl.pause()
      }
    });
    tl.fromTo(`.${year} .t4s-img-as-bg`, { scale: 1.07, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 })
    year_title_animation(tl, year)
    tl.to(`${base_class}`, { autoAlpha: 1 }, `${frame_end_delay}`)
    tl.fromTo(`.${year} .t4s-img-as-bg`, { scale: 1 }, { scale: 1.05, duration: 1.5, repeat: -1, yoyo: true, ease: "sine.inOut" })

  }
  function init_y2020s() {
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y2020s",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
      }
    });
    const year = 'y2020s'
    const base_class2 = `.${year} .t4s-custom-col:nth-of-type(2) .t4s-w-100`
    year_title_animation(tl, year)
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(1)`, { y: "-=30", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.fromTo(`${base_class2} .t4s-img-child:nth-of-type(2)`, { y: "+=30", autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, '<')
    tl.to(`${base_class2}`, { autoAlpha: 1 }, `${frame_end_delay}`)
  }
  function init_y2026() {
    const year = 'y2026'
    const base_class = `.${year} .t4s-custom-col:nth-of-type(1) .t4s-w-100`
    const tl = gsap.timeline({
      defaults: { immediateRender: true },
      scrollTrigger: {
        trigger: ".y2026",
        start: "top 0%",
        end: "bottom 50%",
        toggleActions: "play none none reverse",
        // markers: true,
        onLeaveBack: () => loopTl.pause(0)
      }
    });
    tl.fromTo(`.${year} .t4s-img-as-bg`, { scale: 1.07, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 })
    year_title_animation(tl, year)
    tl.fromTo(`${base_class} .t4s-img-child`, { y: "+=10", autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
    tl.to(`${base_class}`, { autoAlpha: 1 }, `${frame_end_delay}`)

    // 背景呼吸循环独立，初始 paused，前置动画播完启动
    const loopTl = gsap.timeline({ repeat: -1, paused: true });
    loopTl.fromTo(`.${year} .t4s-img-as-bg`, { scale: 1 }, { scale: 1.02, duration: 2, yoyo: true, repeat: 1, ease: "sine.inOut" })
    tl.call(() => loopTl.play())
  }

  function init_video() {
    // 板块根元素通过 code_cus_css 的 "media_video{}" 拿到 .media_video 类
    const sec = document.querySelector('.media_video')
    if (!sec) return
    const video = sec.querySelector('video')
    const ratio = sec.querySelector('.t4s_ratio')
    if (!video || !ratio) return

    // 剥离主题入场动画（hdt-reveal / data-t4s-animate），避免遮住视频
    $(sec).find('[data-t4s-animate], [hdt-reveal]').removeAttr('data-t4s-animate').removeAttr('hdt-reveal')

    // 视频占位图（poster）：复用 CSS 里配置的占位图（Shopify CDN 自动压缩的 JPG），
    // 从计算样式读取其绝对地址，避免地址在两处重复维护
    const bg_image = getComputedStyle(ratio).backgroundImage
    const poster_match = bg_image && bg_image.match(/url\(["']?(.*?)["']?\)/)
    if (poster_match && poster_match[1]) video.poster = poster_match[1]

    // 不做淡入淡出：视频始终显示，只控制播放/暂停
    const pauseVideo = () => video.pause()
    let in_range = false

    // 带声音自动播放：先以有声尝试，被浏览器静音策略拦截时静音兜底播放；
    // 页面首次点击/按键后会自动恢复声音（见下方 unlock_on_gesture）
    const playVideo = () => {
      const tryPlay = (unmuted) => {
        if (!unmuted) video.muted = true
        return video.play().catch(err => {
          // 仅静音策略拦截（NotAllowedError）时才走静音兜底；
          // 其它拒绝（如 onLeave 的 pause() 打断 play 产生的 AbortError）一律忽略，避免自动复活
          if (err && err.name === 'NotAllowedError' && unmuted && in_range) {
            video.muted = true
            video.play().catch(() => { })
          }
        })
      }
      tryPlay(true)
    }

    // 页面任意一次点击/按键后，若视频正处于停留区且是静音播放，自动开声
    // （浏览器禁止无手势的有声自动播放，首次交互后即可恢复声音，iOS 同样有效）
    const unlock_on_gesture = () => {
      if (!in_range || !video.muted || video.paused) return
      video.muted = false
      video.play().catch(() => { video.muted = true })
    }
    window.addEventListener('pointerdown', unlock_on_gesture, { passive: true })
    window.addEventListener('keydown', unlock_on_gesture, { passive: true })

    ScrollTrigger.create({
      trigger: sec,
      start: 'top top',
      end: 'bottom bottom',
      onToggle: (self) => {
        in_range = self.isActive
        if (self.isActive) {
          video.muted = false
          playVideo()
        } else {
          pauseVideo()
        }
      }
    })

    // 供右侧导航使用：整段视频板块（含 sticky 停留）都算 "video" 区间
    year_scroll_triggers['yvideo'] = ScrollTrigger.create({
      trigger: sec,
      start: 'top top',
      end: 'bottom 50%'
    })
  }

  function init_menu() {
    // key 用于定位/高亮（保持稳定，不要随文案变化），label 只负责显示
    const menu_items = [
      { key: 'video', label: 'Brand Film' },
      { key: '1936', label: '1936' },
      { key: '1940', label: '1940' },
      { key: '1950s', label: '1950s' },
      { key: '1960s', label: '1960s' },
      { key: '1970s', label: '1970s' },
      { key: '1980s', label: '1980s' },
      { key: '1990s', label: '1990s' },
      { key: '2000', label: '2000' },
      { key: '2010s', label: '2010s' },
      { key: '2020s', label: '2020s' },
      { key: '2026', label: '2026' }
    ]
    let guide_html = '<div class="years_guide_menu">'
    menu_items.forEach(item => {
      guide_html += `<div class="years_guide_menu_item" data-year="${item.key}"><span>${item.label}</span></div>`
    })
    guide_html += '</div>'
    // 添加菜单到#MainContent的前部
    $('#MainContent').prepend(guide_html)
    $('.years_guide_menu_item').click(function () {
      const key = $(this).attr('data-year')
      // 优先跳到 title_end 标签对应的滚动位置（已越过触发点，动画必定播放），找不到时回退 section 顶部
      const st = year_scroll_triggers[`y${key}`]
      const has_label = !!(st && st.labels && st.labels.title_end != null)
      const fallback_el = key === 'video' ? '.media_video' : `.y${key}`
      const fallback_top = $(fallback_el).length ? $(fallback_el).offset().top : 0
      const target = (has_label ? st.labelToScroll("title_end") : (st ? st.start : fallback_top)) + 10
      smooth_scroll_to(target)
      change_tab_nav(key)
    })
    function change_tab_nav(year) {
      $('.years_guide_menu_item').removeClass('is_selected')
      $(`.years_guide_menu_item[data-year=${year}]`).addClass('is_selected')
    }
    // 滚动监测：根据当前所在年份 section 自动高亮菜单
    function update_menu_on_scroll() {
      const scrollY = $(window).scrollTop()
      let current = null
      menu_items.forEach(item => {
        const st = year_scroll_triggers[`y${item.key}`]
        // 滚动位置落在该 section 的触发区间 [start, end) 内即选中
        if (st && scrollY >= st.start && scrollY < st.end) current = item.key
      })
      if (current) change_tab_nav(current)
    }
    // rAF 节流：滚动时每帧最多计算一次，避免高频 scroll 事件重复遍历
    let menu_ticking = false
    $(window).on('scroll', () => {
      if (menu_ticking) return
      menu_ticking = true
      requestAnimationFrame(() => {
        update_menu_on_scroll()
        menu_ticking = false
      })
    })
  }

  function init() {
    const begin_tl = init_begin()
    init_video()
    init_y1936()
    init_y1940()
    init_y1950s()
    init_y1960s()
    init_y1970s()
    init_y1980s()
    init_y1990s()
    init_y2000()
    init_y2010s()
    init_y2020s()
    init_y2026()


    // init_y2021()
    return begin_tl
  }
  document.addEventListener('DOMContentLoaded', function () {
    // 预加载全部资源期间锁滚动，防止看到缺图/闪画
    document.documentElement.style.overflow = 'hidden'
    const begin_tl = init()
    init_menu()
    init_preload(() => {
      const mask = document.getElementById('anniv_loading')
      if (mask) mask.classList.add('is_done')
      document.documentElement.style.overflow = ''
      // 手机端：加载完成即自动播放首屏动画，无需下滑触发
      // if (MB_is_mobile() && begin_tl) begin_tl.play()
      if (begin_tl) begin_tl.play()
    })
  })
}())